import { AccessTime, Done, DoneAll } from "@material-ui/icons"
import { AlertCircle } from "lucide-react"
import React from "react"

/**
 * @typedef {Object} MessageAckProps
 * @property {number|string} ack - Código do status da mensagem (0 a 5).
 * @property {boolean} isDeleted - Se a mensagem foi apagada.
 * @property {boolean} fromMe - Se a mensagem foi enviada pelo usuário atual.
 * @property {{ palette: { error: { main: string } } }} theme - Tema do Material-UI.
 * @property {import("@material-ui/styles").ClassNameMap} classes - Classes de estilo.
 */

export const MessageAck = React.memo(
  /**
   * @param {MessageAckProps} props
   */
  ({ ack, isDeleted, fromMe, theme, classes }) => {
    if (!fromMe || isDeleted) return null

    const nAck = Number(ack)
    const errorColor = theme?.palette?.error?.main || "#f44336"

    switch (nAck) {
      case 0: // Falha no envio
        return <AlertCircle size={16} fontSize="small" className={classes.ackIcons} style={{ color: errorColor }} />

      case 1: // Enviando
        return <AccessTime fontSize="small" className={classes.ackIcons} />

      case 2: // Enviado
        return <Done fontSize="small" className={classes.ackIcons} />

      case 3: // Entregue (em alguns protocolos)
        return <DoneAll fontSize="small" className={classes.ackIcons} />

      case 4: // Lido
      case 5: // Lido em grupos
        return <DoneAll fontSize="small" className={classes.ackDoneAllIcon} />

      default:
        return null
    }
  },
)

MessageAck.displayName = "MessageAck"
